<template>   
  <div v-if="showTrack">
    <Tracking :track="tracking" :firstName="firstName" :document="document" :showBack="showBack" :isOrder="false" :trackOrder="orderNumber" @hiddenTrack="hiddenTrack" ></Tracking> 
  </div>
  <div class="container" v-else>
      <div class="container-tra">
        <div class="nav-tra">
          <img src="/static/img/logo-tra.png" style="height:30px" />
          <img :src="`data:image/png;base64,${order.accountLogo}`" style="height:35px" v-if="existe == 1 && order.accountLogo != null" />
        </div>  
  
        <div class="msg-order" v-if="existe == 0">
          <div v-if="mobile">
            <img src="/static/img/noencontrado.png" class="img-nf" />
          </div>        
          <div>
            <div class="title-nf">
              No hemos podido encontrar tu pedido
            </div>
            <p class="p-nf">
              Comunicate con nosotros para brindarte información de tu pedido
            </p>
            <br/>
            <button v-on:click="contact()" class="btn btn-ora" style="width:200px">Contáctate con nosotros</button>
          </div>
          <div v-if="!mobile">
            <img src="/static/img/noencontrado.png" class="img-nf" />
          </div>
        </div>  
        <div class="msg-order" v-else-if="existe == 2">
          <div v-if="mobile">
            <img src="/static/img/buscar.png" class="img-bus" />
          </div>        
          <div>
            <div class="title-bus">
              Hola,
            </div>
            <div class="subtitle-bus">
              Bienvenido a Dinet
            </div>            
            <p class="p-bus">
              Para ver el estado de su pedido necesitamos que se identifique:
            </p>
            <p class="p-bus">
                Ingrese tus datos
            </p>
            <form @submit.prevent="search()" autocomplete="off">
              <div class="row">              
                <div class="col-md-12">
                  <div class="form-group">                  
                    <input v-model="firstName" placeholder="Nombres" class="form-control form-control-ora" :class="{ 'is-invalid': submitted && !firstName }"/>
                    <div v-show="submitted && firstName===''" class="invalid-feedback">Los nombres o DNI es requerido</div>
                  </div>
                </div>                                                                                        
              </div>  
              <div class="row">
                <div class="col-xs-12 col-md-6 col-lg-6">   
                  <button v-bind:class="['btn btn-ora', { 'disabled' : (submitted && firstName === '') }]" class="" type="submit">Continuar <i class="fa fa-angle-right" aria-hidden="true"></i></button>
                </div>
              </div>
            </form>                                 
          </div>
          <div v-if="!mobile">
            <img src="/static/img/buscar.png" class="img-bus" />
          </div>
        </div>

        <div class="msg-order" v-else-if="showList">      
          <img src="/static/img/buscar.png" class="img-bus"  v-if="mobile" />  
          <div style="width:100%">
            <div class="title-bus">
                Hola,
            </div>          
            <div class="subtitle-bus">
              {{ order.customerName | firstLetter }}
            </div>                      
            <p class="p-bus">
              Seleccione su pedido:
            </p>            
            <div class="row row-list"  v-for="(track, index) in order.trackingList" :key="index">
              <div class="col-md-12" v-if="!mobile">
                <div class="row">
                  <div class="col-md-1 col-lg-1 data-top">
                    <img :src="track.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'" :class="{ 'data-type': track.orderTypeCode === 'ENT' ? true : false, 'data-type-orange': track.orderTypeCode === 'DEV' ? true : false }" />
                    <span :class="{ 'data-type-label': track.orderTypeCode === 'ENT' ? true : false, 'data-type-orange-label': track.orderTypeCode === 'DEV' ? true : false }"> {{ track.orderTypeCode === 'DEV' ? 'Devolución' : 'Entrega' }} </span>
                  </div>
                  <div class="col-xs-7 col-md-6 col-lg-7 data-top">
                    <span class="data-label">N° Pedido:</span><span class="data-value">{{ track.customerOrderNumber == null ?  orderNumber: track.customerOrderNumber }}</span>
                    <br/>
                    <span class="data-label">N° Tracking:</span><span class="data-value">{{ track.trackingNumber }}</span>                   
                  </div>
                  <div class="col-xs-3 col-md-4 col-lg-3">
                    <span class="data-label">Estado</span>
                    <br/>
                    <div class="data-status" :style="{background: track.configuration.minTextFundColor == '' ? 'black' : track.configuration.minTextFundColor, color: track.configuration.minTextColor == '' ? 'white' : track.configuration.minTextColor }">
                      {{ track.statusDescription | firstLetter }}
                    </div>                    
                  </div>
                  <div class="col-md-1 col-lg-1 data-top">
                    <a class="data-arrow" data-toggle="collapse" v-on:click="goTracking(track)"><i class="fa fa-chevron-right" aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-12" v-else-if="mobile" v-on:click="goTracking(track)">
                <div style="padding-bottom:10px">
                  <img :src="track.orderTypeCode === 'DEV' ? '/static/img/svg/return.svg' : '/static/img/svg/delivery.svg'" :class="{ 'data-type': track.orderTypeCode === 'ENT' ? true : false, 'data-type-orange': track.orderTypeCode === 'DEV' ? true : false }"  />
                  <span :class="{ 'data-type-label': track.orderTypeCode === 'ENT' ? true : false, 'data-type-orange-label': track.orderTypeCode === 'DEV' ? true : false }">{{ track.orderTypeCode === 'DEV' ? 'Devolución' : 'Entrega' }} </span>
                </div>
                <div class="data-status" :style="{background: track.configuration.minTextFundColor == '' ? 'black' : track.configuration.minTextFundColor, color: track.configuration.minTextColor == '' ? 'white' : track.configuration.minTextColor }">
                  {{ track.statusDescription | firstLetter }}
                </div> 
                <div class="row">
                  <div class="col-xs-12 data-mo" style="padding-top: 10px;">
                    <span class="data-label">N° Pedido:</span><span class="data-value">{{ orderNumber }}</span>
                    <br/>
                    <span class="data-label">N° Tracking:</span><span class="data-value">{{ track.trackingNumber }}</span>                   
                  </div>                 
                </div>
              </div>              
            </div>
          </div>
          <img src="/static/img/buscar.png" class="img-bus"  v-if="!mobile" />
        </div>  
      </div>      
  </div>       
</template>
<script>
  import { mapActions } from 'vuex'
  import constants from 'assets/js/constants.js'

  export default {
    name: 'TrackingOrder',
    data () {
      return {
        loader: null,
        mobile: false,
        orderNumber: '',
        name: '',
        tracking: '',
        account: '',
        firstName: '',
        document: '',
        existe: -1,
        showTrack: false,
        showBack: false,
        showList: false,
        order: {},
        submitted: false
      }
    },
    created () {
      this.mobile = this.isMobile()
      this.existe = 2

      this.orderNumber = this.$route.params.order
      this.name = this.$route.params.name
      if (this.$route.params.acc !== undefined) { this.account = this.$route.params.acc }

      if (this.orderNumber !== undefined && this.name !== undefined && this.name !== '') {
        this.firstName = this.name
        this.loader = this.$loading.show({
          loader: 'dots'
        })

        let filter = {
          AccountCode: this.account,
          OrderNumber: this.orderNumber,
          TrackingNumber: '',
          CustomerName: this.name,
          CustomerDNI: ''
        }

        this.getTracking(filter).then((response) => {
          this.loader.hide()
  
          if (response.order != null) {
            this.existe = 1
            this.order = response.order
            if (this.order.trackingList.length === 1) {
              this.tracking = this.order.trackingList[0].trackingNumber
              this.showTrack = true
              this.showBack = true
            } else {
              this.showTrack = false
              this.showBack = false
              this.showList = true
            }
          } else if (response.errorCode > 0) {
            this.existe = 0
          }
        })
      }
    },
    methods: {
      ...mapActions([
        'getTracking'
      ]),
      isMobile () {
        if (screen.width <= 760) {
          return true
        } else {
          return false
        }
      },
      hiddenTrack (value) {
        this.showTrack = value
        if (!this.showList) { this.existe = 2 }
      },
      search () {
        document.activeElement.blur()

        this.submitted = true
        if (this.firstName !== '' || this.document !== '') {
          this.loader = this.$loading.show({
            loader: 'dots'
          })

          let filter = {
            AccountCode: this.account,
            OrderNumber: this.orderNumber,
            TrackingNumber: '',
            CustomerName: this.firstName,
            CustomerDNI: this.document
          }

          this.getTracking(filter).then((response) => {
            this.loader.hide()
  
            if (response.order != null) {
              this.existe = 1
              this.order = response.order
              if (this.order.trackingList.length === 1) {
                this.tracking = this.order.trackingList[0].trackingNumber
                this.showTrack = true
                this.showBack = true
              } else {
                this.showTrack = false
                this.showBack = false
                this.showList = true
              }
            } else if (response.errorCode > 0) {
              this.existe = 0
            }
          })
        }
      },
      goTracking (track) {
        this.tracking = track.trackingNumber
        this.showTrack = true
        this.showBack = true
      },
      contact () {
        window.open(constants.defaultGeneral.urlHelp, '_blank')
      }
    },
    components:
    {
      Tracking: () => import('./TrackingNumber.vue')
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        return value.charAt(0).toUpperCase() + value.toLowerCase().slice(1)
      },
      firstLetter: function (value) {
        if (!value) return ''
        var pieces = value.toString().toLowerCase().split(' ')
        for (var i = 0; i < pieces.length; i++) {
          var j = pieces[i].charAt(0).toUpperCase()
          pieces[i] = j + pieces[i].substr(1)
        }
        return pieces.join(' ')
      },
      minus: function (value) {
        if (!value) return ''
        return value.toString().toLowerCase()
      }
    }
  }
</script>
<style>
  
  @font-face {
    font-family: "Poppins";
    font-weight: 400;
    font-style: normal;
    font-display: auto;
    unicode-range: U+000-5FF;
    src: local("Roboto"), url("/static/Fonts/Poppins/Poppins-Regular.ttf") format("truetype");
  }

  .nav-tra
  {
    padding:10px 16px;
    background-color:white;
    display : flex;
    align-items : center;
    justify-content : space-between;
  }
  
  .container-tra {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #f9f6f6;
    top: 0;
    left: 0;
    font-family : "Poppins"
  }
  
  .msg-order
  {
    margin: 20px;
    background-color: white;
    justify-content: space-evenly;
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    border: 1px solid #DBDFE3;
  }
  
  .title-bus
  {
    color: #0C204E;
    font-size: 24px;
    font-weight: 900;
    margin-top: 20px;
  }

  .subtitle-bus
  {
    color: #0C204E;
    font-size: 24px;        
  }  
  
  .p-bus
  {
    padding-top: 20px;
  }
  
  .img-bus
  {
    padding-left: 20px;
    max-width:400px;
  }

  .form-control-ora
  {
    height: 36px !important;
    border-radius: 8px !important;
  }
 
  .form-control-ora:hover
  {
    border: 1px solid #FF833E;    
  }

  .btn-ora
  {
    height: 36px;
    color:#ffffff;
    background-color: #FF833E;
    width:100%;
    border-radius: 8px;
  }

  .btn-ora:hover
  {
    background-color: #fb5d05;
    color:#ffffff;
  } 
  
  .btn-ora:active
  {
    background-color: #fb5d05;
    color:#ffffff !important;
  }   

  .title-nf
  {
    color: #FF7800;
    font-size: 24px;
    font-weight: 900;
    margin-top: 20px;
  }

  .p-nf
  {
    padding-top: 20px;
  }

  .img-nf
  {
    max-width:400px;
  }  

  .row-list
  {
    border: 1px solid #DBDFE3;
    border-radius: 8px;
    padding: 10px;
    margin: 5px;    
  }

  .data-label
  {  
    font-weight : 900;
    font-size:12px;
    color: #0C204E;
    padding-left: 12px;
  }  

  .data-value
  {
    font-size:12px;    
    color: #7A859D;
    padding-left: 5px;
  }  

  .data-status
  {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 10px;    
    text-align: center;
  }  

  .data-type
  {
    filter: brightness(0) saturate(100%) invert(57%) sepia(82%) saturate(5584%) hue-rotate(211deg) brightness(102%) contrast(101%);
  }

  .data-type-orange
  {
    filter: brightness(0) saturate(100%) invert(43%) sepia(100%) saturate(1269%) hue-rotate(0deg) brightness(102%) contrast(105%);
  }  

  .data-type-label
  {
    color:#3D77FF;
    font-size: 11px;
  }

  .data-type-orange-label
  {
    color:#FF7800;
    font-size: 11px;
  }  

  .data-arrow
  {
    padding-right: 20px;  
    color: #b5b3b3;
    cursor:pointer;
  }  

  .data-top
  {
    padding-top: 10px;    
  }

  .data-mo
  {
    padding-left: 5px;
    padding-right: 5px;
    text-align: left;
  }

  @media screen and (max-width: 414px) {
    .row {
      margin-right: 0px !important;
    }

    .msg-bus {    
      display: block;    
      text-align:center;
    }  
  
    .img-bus
    {
      max-width:250px;
    } 
    
    .msg-order {    
      display: block;    
      text-align:center;
    }  

    .img-nf
    {
      max-width:250px;
    }    
  }
  
  @media screen and (max-width: 320px) {
    .row {
      margin-right: 0px !important;
    }

    .msg-bus {    
      display: block;    
      text-align:center;
    }  
  
    .img-bus
    {
      max-width:250px;
    }

    .msg-order {    
      display: block;    
      text-align:center;
    }  

    .img-nf
    {
      max-width:250px;
    }    
  }

</style>



// WEBPACK FOOTER //
// TrackingOrder.vue?103a7808